import React, { Component, MouseEvent } from 'react'
import { EditorState } from 'draft-js'
import { Subject, Subscription } from 'rxjs'
import { collapseSelection } from '../../pluginCommon/pluginHelpers'
import AnnotationsModal from './AnnotationModal'
import EditIcon from '../icons/Edit.js'
import $ from 'jquery'
import RemoveLinkIcon from '../icons/RemoveLink.js'
import { removeEntity, forceAnnotationSelection } from '../editorUtils'
import intl from 'react-intl-universal'
interface UpdateRemoveModalProps {
  formSubject: Subject<any>
  getEditorState: () => EditorState
  setEditorState: (editorState: EditorState) => void
  updateInlineToolbar: (
    visibility: boolean,
    content?: (props: any) => JSX.Element
  ) => void
  theme: any
  editParams: any
}

export default class UpdateRemoveModal extends Component<
  UpdateRemoveModalProps,
  any
> {
  isEditing: boolean

  subscribtion?: Subscription | null

  constructor(props) {
    super(props)
    this.isEditing = false
  }

  componentDidMount() {
    this.subscribtion = this.props.formSubject.subscribe(this.onFormStateChange)
  }

  componentWillUnmount() {
    this.subscribtion && this.subscribtion.unsubscribe()
  }

  onFormStateChange = (params) => {
    if (!this.isEditing && (!params || params.type === 'editor')) {
      this.onClose()
    }
  }

  clearSelection = (editorState: EditorState) => {
    return EditorState.forceSelection(
      editorState,
      collapseSelection(editorState.getSelection())
    )
  }

  onClose = () => {
    this.subscribtion && this.subscribtion.unsubscribe()
    this.subscribtion = null
    this.props.updateInlineToolbar(false)
  }

  displayEditModal = () => {
    this.isEditing = true
    const {
      updateInlineToolbar,
      setEditorState,
      getEditorState,
      editParams,
    } = this.props
    $('#open-edit-annotation-btn').tooltip('hide')
    forceAnnotationSelection(setEditorState, getEditorState, editParams)
    updateInlineToolbar(true, (props) => (
      <AnnotationsModal
        {...props}
        {...this.props}
        isEditting={this.isEditing}
      />
    ))
  }

  removeAnnotation = (e: MouseEvent) => {
    e.stopPropagation()
    $('#remove-annotation-btn').tooltip('hide')
    const { getEditorState, setEditorState, updateInlineToolbar } = this.props
    setEditorState(removeEntity(getEditorState()))
    updateInlineToolbar(false)
  }

  preventDefault = (e: MouseEvent) => {
    e.preventDefault()
  }

  render() {
    const { theme } = this.props
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        onMouseDown={this.preventDefault}
        data-testid="edit/remove-annotation-modal"
      >
        <button
          className={theme.button}
          onClick={this.displayEditModal}
          id="open-edit-annotation-btn"
          data-toggle="tooltip"
          title={intl.get('annotationPlugin.editremove.modal.edit.hover')}
        >
          <EditIcon />
        </button>
        <button
          className={theme.button}
          onClick={this.removeAnnotation}
          id="remove-annotation-btn"
          data-toggle="tooltip"
          title={intl.get('annotationPlugin.editremove.modal.remove.hover')}
        >
          <RemoveLinkIcon />
        </button>
      </div>
    )
  }
}
